<template>
  <a class="player-btn-wrapper" title="player btn">
    <svg :width="width" :height="height" :class="playerBtnType"
         viewBox="0 0 80 80" class="player-btn" @click="btnOnClick"
    >
      <circle class="circle-base" cx="40" cy="40" r="38" />
      <circle ref="circleTrack" :class="playerBtnRoundStatus" class="circle-track" cx="40" cy="40" r="38" />
      <path v-if="playerBtnPaused" class="play-btn" d="M31.93 52.033V27.967a3.059 3.059 0 0 1 4.844-2.482l16.723 12.032a3.059 3.059 0 0 1 0 4.966L36.774 54.515a3.059 3.059 0 0 1-4.845-2.482z" />
      <path v-if="!playerBtnPaused" :class="playerBtnRoundStatus" class="pause-btn" d="M45.04 23H55v35h-9.96V23zM25 58V23h9.96v35H25z" />
    </svg>
  </a>
</template>
<script>
export default {
  name: 'PlayerBtn',
  components: {},
  props: {
    width: {
      type: [Number, String],
      default: 80
    },
    height: {
      type: [Number, String],
      default: 80
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String, // static, round
      default: 'static'
    },
    inList: {
      type: Boolean,
      default: false
    },
    inListTrackId: {
      type: String,
      default: ''
    },
    inListIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  computed: {
    paused() {
      return this.$store.state.player.paused
    },
    currentTime() {
      return this.$store.state.player.currentTime
    },
    duration() {
      return this.$store.state.player.duration
    },
    currentIndex() {
      return this.$store.state.player.index
    },
    currenTrackId() {
      return this.$store.state.player.trackId
    },
    playerBtnType() {
      const isDisabled = this.disabled ? ' disabled' : '' // notice spaces between class
      return this.type === 'static'
        ? 'static' + isDisabled
        : 'round' + isDisabled
    },
    playerBtnPaused() {
      return this.inList
        ? (this.currenTrackId === this.inListTrackId && this.inListIndex === this.currentIndex)
          ? this.paused
          : true
        : this.paused
    },
    playerBtnRoundStatus() {
      if (!this.inList) {
        if (!this.paused && this.currentTime) {
          return 'playing'
        } else if (this.paused && this.currentTime) {
          return 'pausing'
        } else {
          return '' // not start playing, grey
        }
      } else {
        if ((this.currenTrackId === this.inListTrackId) &&
           (this.inListIndex === this.currentIndex) && this.currentTime) {
          return this.paused ? 'pausing' : 'playing'
        }
        return ''
      }
    }
  },
  watch: {
    currentTime() {
      if (this.type === 'round' && !this.playerBtnPaused) {
        // update circle track length
        const r = this.$refs.circleTrack.r.baseVal.value // Radius, default 38px
        const c = 2 * Math.PI * r // Circumference, formula: 2 π r
        const percentageLength = `${(this.currentTime / this.duration) * c}, ${c}`
        this.$refs.circleTrack.style.strokeDasharray = percentageLength
      }
    }
  },
  created() {},
  mounted() {},
  updated() {},
  methods: {
    btnOnClick() {
      this.$emit('click')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.player-btn {
  &-wrapper {
    display: inline-block;
    text-decoration: none;
    cursor: pointer;
  }
  .circle-base {
    fill: none;
    stroke: $grey-ec;
    stroke-width: 3px;
  }
  .circle-track {
    transform-origin: 50% 50%;
    transform: rotate(-90deg);
    stroke: $grey-ec;
    stroke-width: 3px;
    fill: none;
    stroke-dasharray: 0, 0;
    stroke-linecap: square; // square, round;
  }
  .play-btn {
    fill: $grey-50;
    transition: fill 0.2s linear;
  }
  .pause-btn {
    fill: $grey-50;
    transition: fill 0.2s linear;
  }
}

.player-btn.static {
  .circle-track.playing {
    stroke: $theme-red;
  }
  .pause-btn.playing {
    fill: $theme-red;
  }
}

.player-btn.round {
  .circle-track {
    transition: stroke-dasharray .2s linear; // just for track round smoothly
  }
  .circle-track.playing {
    stroke: $theme-yellow;
  }
  .circle-track.pausing {
    stroke: $theme-yellow;
  }
  // .play-btn {
  //   fill: $grey-50;
  // }
  // .pause-btn.playing {
  //   fill: $grey-ec;
  // }
}
//
// disabled status
//
.player-btn.disabled {
  .circle-track {
    stroke: $grey-ec;
  }
  .play-btn {
    fill: $grey-ec;
  }
  .pause-btn {
    fill: $grey-ec;
  }
}
//
// hover status
//
@media (hover: hover) {
  .player-btn {
    &.static:hover {
      .circle-track.playing {
        stroke: $grey-9b;
      }
      .play-btn,
      .pause-btn {
        fill: $grey-9b;
      }
    }
    &.round:hover {
      .circle-track.playing {
        // stroke: $grey-9b; //
      }
      .play-btn,
      .pause-btn {
        fill: $grey-9b;
      }
    }
  }
  .player-btn.disabled {
    cursor: not-allowed;
    &.static:hover {
      .circle-track.playing {
        stroke: $grey-ec;
      }
      .play-btn,
      .pause-btn {
        fill: $grey-ec;
      }
    }
    &.round:hover {
      .circle-track.playing {
        // stroke: $grey-ec; //
      }
      .play-btn,
      .pause-btn {
        fill: $grey-ec;
      }
    }
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}
</style>
